
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/manage-groups/jst/groupUser';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "<i>(";
  if (helper = helpers.pronouns) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.pronouns); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + ")</i>";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <span style=\"margin-left:0.5em\" class=\"label\"\n        title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_user")
  },data:data},helper ? helper.call(depth0, "this_user_is_currently_not_able_to_access_the_cour_39cabed1", "This user is currently not able to access the course", options) : helperMissing.call(depth0, "t", "this_user_is_currently_not_able_to_access_the_cour_39cabed1", "This user is currently not able to access the course", options)))
    + "\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_user")
  },data:data},helper ? helper.call(depth0, "inactive_cd40317f", "inactive", options) : helperMissing.call(depth0, "t", "inactive_cd40317f", "inactive", options)))
    + "\n  </span>\n";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "<i class=\"icon-user group-leader\"\n  aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_user")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_user.group_leader", "Group Leader", options) : helperMissing.call(depth0, "t", "groups.manage.group_user.group_leader", "Group Leader", options)))
    + "\"\n  title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_user")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_user.group_leader", "Group Leader", options) : helperMissing.call(depth0, "t", "groups.manage.group_user.group_leader", "Group Leader", options)))
    + "\"></i>";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <a role=\"button\"\n     href=\"#\"\n     data-user-id=\"user_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n     class=\"assign-to-group\"\n     aria-haspopup=\"true\"\n     aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_scope': ("groups.manage.group_user")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_user.assign_user_to_group", "Assign %{name} to a group", options) : helperMissing.call(depth0, "t", "groups.manage.group_user.assign_user_to_group", "Assign %{name} to a group", options)))
    + "\">\n      <i class=\"icon-plus\"></i>\n  </a>\n";
  return buffer;
  }

  buffer += "<div class=\"group-user-name ellipsis\">\n  <i class=\"icon-drag-handle\" aria-hidden=\"true\"></i>\n  ";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.pronouns), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.is_inactive), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isLeader), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canAssignToGroup), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<div id=\"group_";
  if (helper = helpers.groupId) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.groupId); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_user_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_menu_selector\" style=\"position: absolute; top: -2px; right: 0;\"></div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  